angular.module 'zc.commonApi'

.factory 'Inquiry', ($resource, Api, $q, $injector) ->
  Inquiry = $resource Api.path("/api/inquiry/")
  service =
    reasons: null
    create: (projectId, message, reason) ->
      # workaround to show loading spinner without wait
      NotificationChannel = $injector.get('NotificationChannel')
      NotificationChannel.requestStarted()
      inquiry = new Inquiry
        message: message
        reason: reason
      d = $q.defer()
      inquiry.$save().then (res) ->
        d.resolve res.inquiry
      d.promise
    getReasons: ->
      if service.reasons
        $q.when service.reasons
      else
        d = $q.defer()
        Api.get('/api/inquiry/reasons').then (res) ->
          service.reasons = res.data.reasons
          d.resolve service.reasons
        d.promise
  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/inquiry_service.js.coffee